export default "__VITE_ASSET__54aac401__"